/**
 *  글로벌 윈도우 데이터 저장용 키
 * @since 0.0.1
 * @author Heungsoo Ham
 * @enum
 */
export enum WindowKey {
    PRODUCT = "___product",
    DESIGNMODE = "___designMode",
    POPUPMODE = "___popupMode",
    PREVIEWMODE = "___previewMode",
    PREVIEWSTRING = "___previewString",
    ROOTMODE = "___rootMode",
    RUNTIMEMODE = "___runtimeMode",
    VERSIONMODE = "___versionMode",
    PUBLISHID = "___publishId",
    APPLICATIONID = "___applicationId",
    FORMID = "___formId",
    PROJECTID = "__projectId",
    PROCID = "___procid",
    WORKSEQ = "___workseq",
    ACTSEQ = "___actseq",
    ACCESSIBILITY = "___accessibility",
    CUSTOMCOMPONENT = "___customComponent",
    MANIFEST = "BizFormManifest",
    CORELIBRARY = "BizFormCore",
    HELPERLIBRARY = "BizFormHelper",
    DESIGNLIBRARY = "BizFormDesign",
    APPLIBRARY = "BizFormApp",
    APPTOOLCOMMONLIBRARY = "BizFormPrimeReactAppTool",
    APPTOOLDODUMENTATIONLIBRARY = "BizFormDocument",
    APPTOOLMODELERLIBRARY = "BizFormModeler",
    APPTOOLSTUDIOLIBRARY = "BizFormStudio"
}
